import React, { Component } from 'react'
import PropTypes from 'prop-types'

import VideoPlayer from '../components/VideoPlayer'
import VideoMarkers from '../components/VideoMarkers'

class TopicVideo extends Component {

  static propTypes = {
    video: PropTypes.object.isRequired,
    time: PropTypes.number,
    onVideoMarkerClick: PropTypes.func,
    onPlay: PropTypes.func,
  }

  render() {
    const { video, onVideoMarkerClick, time } =  this.props

    const videoProps = {
      poster: video.thumbnailLink,
      autoplay: !!time, // enable autoplay when there is a time offset for video playback
      controls: true,
      playsinline: true,
      sources: [{
        src: video.externalLink,
        type: 'video/mp4'
      }],
      time: time
    }

    return (
      <div className="video-container">
        <div className="video-player-container">
          <VideoPlayer { ...videoProps } onPlay={this.props.onPlay} />
        </div>
        {video.markers && <VideoMarkers items={video.markers}
          onClick={(t) => onVideoMarkerClick && onVideoMarkerClick(t)} />}
      </div>
    )
  }
}

export default TopicVideo
